import React, { useState } from 'react';
import { Home, Building2, Package, Wrench } from 'lucide-react';
import { Button } from './ui/button';
import { services } from '../data/mock';
import QuoteModal from './QuoteModal';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const iconMap = {
  Home: Home,
  Building2: Building2,
  Package: Package,
  Wrench: Wrench,
};

const Services = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [titleRef, titleVisible] = useScrollAnimation(0.1);
  const [cardsRef, cardsVisible] = useScrollAnimation(0.1);

  return (
    <section id="servicos" className="py-20 bg-white relative overflow-hidden">
      {/* Animated background */}
      <div className="absolute inset-0 opacity-50">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-[#1FA2FF]/10 rounded-full blur-3xl animate-float"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#0077C8]/10 rounded-full blur-3xl animate-float" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div 
          ref={titleRef}
          className={`text-center mb-16 ${titleVisible ? 'animate-fade-in-up' : 'animate-on-scroll'}`}
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-[#071028] mb-4">
            Serviços de Mudanças em Lisboa e Portugal
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Soluções completas para todas as suas necessidades de mudança e transporte
          </p>
        </div>

        <div ref={cardsRef} className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className={`group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-3 hover-lift ${
                  cardsVisible ? 'animate-scale-in' : 'animate-on-scroll'
                } delay-${index + 1}00`}
              >
                {/* Image */}
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-125 group-hover:rotate-2 transition-all duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#071028]/95 via-[#071028]/60 to-transparent group-hover:from-[#1FA2FF]/90 transition-all duration-500"></div>
                  
                  {/* Icon */}
                  <div className="absolute top-4 right-4 w-12 h-12 bg-gradient-to-br from-[#1FA2FF] to-[#0077C8] rounded-xl flex items-center justify-center group-hover:scale-125 group-hover:rotate-12 transition-all duration-300 shadow-lg">
                    <Icon className="w-6 h-6 text-white" />
                  </div>

                  {/* Shine effect on hover */}
                  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                  </div>
                </div>

                {/* Content */}
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform group-hover:translate-y-0 transition-transform duration-300">
                  <h3 className="text-xl font-bold mb-2 group-hover:scale-105 transition-transform duration-300">{service.title}</h3>
                  <p className="text-gray-200 text-sm mb-4">{service.description}</p>
                  <Button
                    onClick={() => setIsModalOpen(true)}
                    className="w-full bg-[#1FA2FF] hover:bg-[#0077C8] text-white font-semibold transition-all duration-300 hover:scale-105 hover:shadow-xl"
                  >
                    Solicitar Orçamento
                  </Button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <QuoteModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </section>
  );
};

export default Services;
